import { useCalculate } from "@/modules/dwelling/containers/DwellingEstimateContainer/Calculate/useCalculate.tsx";
import styles from "@/modules/dwelling/containers/DwellingEstimateContainer/DwellingEstimateContainer.module.scss";

export const DwellingEstimateTotal = () => {
  const { costingCalculate } = useCalculate();

  return (
    <div className={styles.totalSection}>
      <h3 className={styles.totalTitle}>Total des réparations à réaliser :</h3>
      <div className={styles.totalInfoLine}>
        Montant HT :{" "}
        <strong>{costingCalculate.total.preTaxPrice.toFixed(2)} €</strong>
      </div>
      <div className={styles.totalInfoLine}>
        Vétusté déduite :{" "}
        <strong>
          -{costingCalculate.total.dilapidationDeducted.toFixed(2)} €
        </strong>
      </div>
      <div className={styles.totalInfoLine}>
        TVA : <strong>{costingCalculate.total.taxAmount.toFixed(2)} €</strong>
      </div>
      <div className={styles.totalInfoLine}>
        Montant TTC :{" "}
        <strong>{costingCalculate.total.total.toFixed(2)} €</strong>
      </div>
    </div>
  );
};
